import React from 'react';
import PropTypes from 'prop-types';

import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import List from '@material-ui/core/List';
import { CHILDREN_PROPTYPES } from 'bento-ordering/base/constants/propTypes';

const LocationListSection = ({ children, title, dataTestId }) => {
  return (
    <Box mb={5} data-testid={dataTestId}>
      <Box mb={2.5}>
        <Typography color="textPrimary" variant="h1">
          {title}
        </Typography>
      </Box>

      <List>{children}</List>
    </Box>
  );
};

LocationListSection.propTypes = {
  children: CHILDREN_PROPTYPES.isRequired,
  title: PropTypes.string.isRequired,
  dataTestId: PropTypes.string.isRequired
};

export default LocationListSection;
